
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"highlight-fill",attrs:{"d":"M12.8.5H3.6C2.7.5 2 1.2 2 2.1v14.8l6.1-3.6 6.1 3.6V2.1c.1-.9-.6-1.6-1.4-1.6zm0 13.7l-4.6-2.7-4.6 2.7v-12c0-.1.1-.2.2-.2h8.8c.1 0 .2.1.2.2v12z","fill":"#fff"}})])
          )
        }
      }
    